<template>
  <div id="calendar"></div>
</template>

<script>
  import 'vue-full-calendar'
  import 'fullcalendar/dist/fullcalendar.css'

  export default {
    name: 'calendar',
    props: {
      value: {
        type: Array,
        default: function () {
          return []
        }
      },
      height: {
        type: Number,
        default: function () {
          return 600;
        }
      }
    },
    watch: {
      value: function (val) {
        // value(events)가 변경 될 때 마다 캘린더에 events render
        $(this.$el).fullCalendar('renderEvents', val)
      }
    },
    data: function () {
      return {
      }
    },
    methods: {
      init: function () {
        var vm = this
        var calendar = $(this.$el)

        // Calendar init
        // Object.assign(calendar.fullCalendar, this.options)
        calendar.fullCalendar({
          lang: 'ko',
          header: {
            left: '',
            center: 'prev title next',
            right: ''
          },
          viewRender: function (view, element) {
            // 캘린더가 render 될 시 getViewDate 함수 실행
            vm.getViewDate()
          },
          events: this.value,
          eventClick: function (event, jsEvent, view) {
            // 스케쥴 클릭 시 event
            vm.$emit('click', event.id)
          },
          eventColor: '#ffffff',
          eventAfterRender: function (event, element, view) {
            const vm = this
            var today = moment()

            // 종료일자가 오늘보다 이전이면 더 옅은처리를 한다.
            if (event.end < today) {
              element.css('border-color', '#DEE2E6')
              element.css('background-color', '#DEE2E6')
            // 시작일과 끝이 하루 차이난다는 것은 당일날 이라는 의미이므로 강조표시를 한다.
            } else if (event.end.diff(event.start, 'days') === 1) {
              element.css('border-color', '#F76707')
              element.css('background-color', '#F76707')
            } else {
              element.css('border-color', '#868e96')
              element.css('background-color', '#868e96')
            }
          },
          eventLimit: true, // for all non-agenda views
          views: {
            agenda: {
              eventLimit: 20 // adjust to 6 only for agendaWeek/agendaDay
            }
          },
          // eventRender: function (event, element) {
          //   element.popover({
          //     animation: true,
          //     delay: 300,
          //     placement: 'auto',
          //     content: event.title,
          //     trigger: 'hover'
          //   })
          // },
          displayEventTime: false,
          // editable: true,
          // eventDrop: function (event, delta, revertFunc) {
          //   if (!confirm('변경하시겠습니까?')) {
          //     revertFunc()
          //   }
          // },
          titleFormat: 'YYYY년 M월',
          locale: 'ko',
          height: vm.height
        })
      },
      getViewDate: function () {
        // 현재 캘린더에 시작일과 종료일을 기준으로 캘린더 데이터 Update
        const calendar = $(this.$el)
        const date = {
          year: calendar.fullCalendar('getView').title.split('년')[0],
          start: moment(calendar.fullCalendar('getView').start._d).format('YYYY-MM-DD'),
          end: moment(calendar.fullCalendar('getView').end._d).format('YYYY-MM-DD')
        }
        // 부모 페이지에 updateCalendar 이벤트 실행
        this.$emit('updateCalendar', date)
      }
    },
    mounted: function () {
      this.init()
    }
  }
</script>

<style lang="scss">
  #calendar {
    .fc-header-toolbar {
      width: 100%;
      height: 64px;
      padding: 20px 0;
      margin: 0 !important;

      .fc-center {
        height: 100%;
        display: inline-block;
        margin: 0;

        > button {
          height: 24px;
          padding: 4px 8px;
          border-radius: 2px;
          color: $hzc-gray-06;
          border: 0;
          margin: 0;
          box-sizing: border-box;
          cursor: pointer;

          &:hover {
            .fc-icon {
              color: $primary-color-v2;
            }
          }

          &:focus {
            outline: none;
          }

          &:last-child {
            margin-left: 1em;
          }
        }

        h2 {
          display: inline-block;
          font-size: 20px;
          line-height: 24px;
        }

        .fc-state-default {
          background-color: $hzc-white;
          background-image: none;
          background-repeat: no-repeat;
          border-color: none;
          text-shadow: none;
          box-shadow: none;
        }
      }
    }

    .fc-toolbar {
      text-align: center;
      margin: 0;
    }

    .fc-more {
      color: $hzc-gray-05 !important;
    }

    .fc-content {
      color: $hzc-white;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/Calendar.vue